import React from 'react';
import Config from '../shared/Config';
import useStatusApi, { normalizeStatusApiError } from './useStatusApi';

const { apiBaseUrl } = Config();

export default function useIncident(incidentId) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const { ready, get } = useStatusApi();

  React.useEffect(() => {
    if (!ready) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);

    get(`${apiBaseUrl}/incident/${incidentId}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (cancelled) return;
        setItems(response.data.data.attributes.incidents);
        setLoading(false);
      })
      .catch((requestError) => {
        if (cancelled) return;
        setError(normalizeStatusApiError(requestError));
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [get, incidentId, ready]);

  return { loading, items, error };
}
